module.exports = __webpack_public_path__ + "img/1503935755.86c4f69c.jpg";